import { useIntl } from 'react-intl';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import { useExperiments } from '@alltrails/experiments';
import useAlgoliaConfigs from '@alltrails/context/hooks/useAlgoliaConfigs';
import { useMemo } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import getNaturalLanguageSearchUrl from '@alltrails/search/utils/getNaturalLanguageSearchUrl';
import styles from './styles.module.scss';

const HomeSearchBar = () => {
  const intl = useIntl();
  const experiments = useExperiments();
  const algoliaConfigs = useAlgoliaConfigs();
  const languageRegionCode = useLanguageRegionCode();

  const naturalLanguageSearchEnabled = experiments['web-ai-natural-language-search']?.value === 'treatment';
  const handleNaturalLanguageResultSelect = useMemo<((query: string) => void) | undefined>(() => {
    if (!naturalLanguageSearchEnabled) {
      return undefined;
    }
    return query => {
      const url = getNaturalLanguageSearchUrl(query, languageRegionCode);
      window.location.assign(url);
    };
  }, [languageRegionCode, naturalLanguageSearchEnabled]);

  const placeholder = naturalLanguageSearchEnabled
    ? intl.formatMessage({ defaultMessage: 'Search for anything' })
    : intl.formatMessage({ defaultMessage: 'Search by city, park, or trail name' });

  return (
    <div className={styles.container}>
      <AlgoliaSearchBox
        className={styles.search}
        configs={algoliaConfigs}
        navigateOnSelect
        onNaturalLanguageResultSelect={handleNaturalLanguageResultSelect}
        placeholder={placeholder}
        searchOrigin="homepage"
        searchTypes="all"
        size="homepage"
        testId="homepage-search-box"
        useTypeAhead
      />
    </div>
  );
};

export default HomeSearchBar;
